<ng-container *featureToggle="features.TEST_FEATURE_TOGGLE_EVEN">
  <!-- TEST_FEATURE_TOGGLE_EVEN: for testing purposes only, no impact on other elements -->
  <div data-testid="test-feature-toggle-even"></div>
</ng-container>
<ng-container *featureToggle="features.TEST_FEATURE_TOGGLE_ODD">
  <!-- TEST_FEATURE_TOGGLE_ODD: for testing purposes only, no impact on other elements -->
  <div data-testid="test-feature-toggle-odd"></div>
</ng-container>

<div class="flex justify-end items-center even-spacing global-right-header">
  <!-- @ LOCALHOST only -->
  @if (hostname === 'localhost') {
    <span class="flex justify-end items-center flex-[1_1_0%] max-md:hidden">
      <app-languages (languageName)="setLang($event)"></app-languages>
    </span>
  }

  <!-- Organisation -->
  @if (currentUser()) {
    @if (sapIsEnabled$$() || hasNonDemoOrg()) {
      <button
        mat-button
        class="organisation-selector"
        [class.org-name-lg]="lgMedia()"
        [class.org-name-xl]="xlMedia()"
        #organisationPickerTrigger="matMenuTrigger"
        [matMenuTriggerFor]="organisationPicker"
        (menuOpened)="trackOpenOrgSelector()"
        tabindex="0"
        data-testid="organisation-select-button">
        @if (currentOrganisation()) {
          <ng-container [ngTemplateOutlet]="leMdMedia() ? leOrgView : lgOrgView"> </ng-container>
        }
        <span class="organisation-selector-menu-icon ml-1">
          @if (organisationPickerTrigger.menuOpen) {
            <claas-icon iconId="659459" namespace="cc" [size]="24"> </claas-icon>
          } @else {
            <claas-icon iconId="659458" namespace="cc" [size]="24"> </claas-icon>
          }
        </span>
      </button>
    } @else {
      <div class="mx-4 flex">
        <ng-container [ngTemplateOutlet]="leMdMedia() ? leOrgView : lgOrgView"> </ng-container>
      </div>
    }
  }
  <mat-menu #organisationPicker="matMenu" class="org-menu" xPosition="before" backdropClass="pc">
    @if ({ user: user$ | async, dialogSteps: registrationDialogSteps$ | async }; as data) {
      @if (!hasNonDemoOrg()) {
        <button
          mat-menu-item
          class="menuButton"
          data-testid="create-organisation"
          tabindex="0"
          (click)="registerOrganisation(data.user, $safeNavigationMigration(data?.dialogSteps?.steps))">
          <div class="flex items-center">
            <div class="flex items-center">
              <claas-icon class="add-icon" iconId="648541" namespace="cc" [size]="22"> </claas-icon>
              <span class="create-organization">{{ 'organisationSelector.create' | translate }}</span>
            </div>
          </div>
        </button>
      }
      @for (org of organisations(); track org.id) {
        <button
          mat-menu-item
          class="menuButton"
          [class.activeOrg]="currentOrganisation() == org"
          [ngClass]="{ 'is-registered-org': org.registered, 'is-demo-org': !org.registered }"
          (click)="setCurrentOrganisation(org)"
          [attr.data-testid]="'organisation-' + org.name | lowercase">
          <div class="flex items-center" tabindex="0">
            <claas-icon
              class="org-selector-farm-icon grid"
              iconName="agricultural_buisness_farm"
              [iconStyle]="'bold'"
              namespace="cc"
              [size]="22"
              [matBadge]="org.notificationCount"
              [matBadgeHidden]="org.notificationCount === 0"
              matBadgeSize="small">
            </claas-icon>
            <span class="organization-name">{{ org.name }}</span>
          </div>
        </button>
      }
      @if (hasNonDemoOrg()) {
        <ng-container *hasPermissions="manageOrgPermission">
          <span class="block my-1"><mat-divider></mat-divider></span>
          <button
            mat-menu-item
            class="menuButton"
            tabindex="1"
            (click)="gotoClaasIdInviteUser()"
            data-testid="invite-user-button">
            <div class="flex items-center">
              <claas-icon class="edit-icon" iconId="750372" namespace="cc" [size]="22"> </claas-icon>
              <span class="manage-organization">{{ 'organisationSelector.invite_user' | translate }}</span>
              <claas-icon [removeDefaultColor]="true" class="open-in-new" iconId="659469" namespace="cc" [size]="16">
              </claas-icon>
            </div>
          </button>
        </ng-container>

        @if (sapIsEnabled$$()) {
          <span class="block my-1"><mat-divider></mat-divider></span>
          <button
            mat-menu-item
            class="menuButton"
            data-testid="create-organisation"
            tabindex="0"
            (click)="registerOrganisation(data.user, $safeNavigationMigration(data?.dialogSteps?.steps))">
            <div class="flex items-center">
              <div class="flex items-center">
                <claas-icon class="add-icon" iconId="648541" namespace="cc" [size]="22"> </claas-icon>
                <span class="create-organization">{{ 'organisationSelector.new_org' | translate }}</span>
              </div>
            </div>
          </button>
        }
      }
    }
  </mat-menu>

  <ul class="header-icons-list">
    <li class="max-sm:w-[30px]">
      <app-help-menu [currentUser]="currentUser()" [currentOrganisation]="currentOrg() ?? null"></app-help-menu>
    </li>
    <li class="max-sm:w-[30px]" *hasPermissions="platformAdvanced">
      @if (currentUser()) {
        <app-notifications-panel
          (getNotifications)="refreshNotifications()"
          [notifications]="notifications()"
          [notificationsLoading]="notificationsLoading()"
          [newNotificationsCount]="newNotificationsCount$$()">
        </app-notifications-panel>
      }
    </li>
    <ng-container *featureToggle="features.NEW_PARTS_SHOP">
      <li class="max-sm:w-[30px]">
        @if (currentUser()) {
          <app-mini-cart></app-mini-cart>
        }
      </li>
    </ng-container>
    <li class="max-sm:w-[30px]">
      <!-- App Selector -->
      <claas-icon-button
        data-testid="app-launcher-menu-button"
        tabindex="0"
        [matMenuTriggerFor]="appDrawer"
        (menuOpened)="trackOpenAppSelector()"
        [icon]="{ iconId: '648467', namespace: 'cc', iconStyle: 'bold' }"></claas-icon-button>
    </li>
  </ul>
  <mat-menu #appDrawer="matMenu" class="app-drawer-menu" xPosition="before" backdropClass="pc">
    <app-app-launcher class="w-[380px] block"></app-app-launcher>
  </mat-menu>
  <!-- User -->
  <button
    mat-icon-button
    data-testid="user-profile-button"
    class="user-icon"
    [class.active-user-icon]="userMenuTrigger.menuOpen"
    #userMenuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="userMenu"
    (menuOpened)="trackOpenAccountMenu()"
    tabindex="0">
    <img [src]="currentUser()?.picture ?? '/assets/icons/icon-user.svg'" class="user-icon-image" alt="user" />
  </button>

  <mat-menu #userMenu="matMenu" class="user-menu-container" xPosition="before" backdropClass="pc">
    <div data-testid="user-profile-settings-panel">
      <div class="user flex flex-col mt-6 mb-4">
        <span>
          <img
            [src]="currentUser()?.picture ?? '/assets/icons/icon-user.svg'"
            alt="user"
            data-testid="user-profile-image" />
          <span class="heading-h6" data-testid="user-profile-name">
            {{ currentUser()?.user_metadata?.given_name }} {{ currentUser()?.user_metadata?.family_name }}
          </span>
          <span class="mat-body-2 email" data-testid="user-profile-email">{{ currentUser()?.email }}</span>
        </span>
      </div>

      <span class="block my-1"><mat-divider></mat-divider></span>

      <button mat-menu-item (click)="onClaasIdSettings('personal-data')" class="claas-id">
        <span class="flex items-center">
          <claas-icon class="user-menu-icon" [removeDefaultColor]="true" iconId="648427" namespace="cc" [size]="24">
          </claas-icon>
          <span>{{ 'navbar.user_menu.manage_claas_id.personal_data' | translate }}</span>
        </span>
        <claas-icon
          [removeDefaultColor]="true"
          class="user-menu-icon open-in-new"
          iconId="659469"
          namespace="cc"
          [size]="16">
        </claas-icon>
      </button>

      <button mat-menu-item (click)="onClaasIdSettings('user-settings')" class="claas-id">
        <span class="flex items-center">
          <claas-icon class="user-menu-icon" [removeDefaultColor]="true" iconId="648466" namespace="cc" [size]="24">
          </claas-icon>
          <span>{{ 'navbar.user_menu.manage_claas_id.user_settings' | translate }}</span>
        </span>
        <claas-icon
          [removeDefaultColor]="true"
          class="user-menu-icon open-in-new"
          iconId="659469"
          namespace="cc"
          [size]="16">
        </claas-icon>
      </button>

      <button mat-menu-item (click)="onClaasIdSettings('organisations')" class="claas-id">
        <span class="flex items-center">
          <claas-icon class="user-menu-icon" [removeDefaultColor]="true" iconId="783207" namespace="cc" [size]="24">
          </claas-icon>
          <span>{{ 'navbar.user_menu.manage_claas_id.organisation_settings' | translate }}</span>
        </span>
        <claas-icon
          [removeDefaultColor]="true"
          class="user-menu-icon open-in-new"
          iconId="659469"
          namespace="cc"
          [size]="16">
        </claas-icon>
      </button>

      <span class="block my-1"><mat-divider></mat-divider></span>

      <div class="logout">
        <claas-button
          data-testid="my-reports-button"
          class="w-full"
          buttonClass="secondaryOutline"
          [stretch]="true"
          (click)="onLogout()"
          ><claas-icon iconId="659471" namespace="cc" iconStyle="bold" />{{ 'navbar.logout' | translate }}
        </claas-button>
      </div>
      <div class="links">
        @if (legalTextLinks$$()) {
          @for (legalTextLink of legalTextLinks$$(); track legalTextLink.link) {
            <a [href]="legalTextLink.link" target="_blank">
              {{ legalTextLink.label | translate }}
            </a>
          }
        }

        <a onclick="UC_UI.showSecondLayer()">
          {{ 'navbar.privacy' | translate }}
        </a>
        <a *featureToggle="features.EUROPEAN_DATA_ACT_EXPORT" href="{{ dataActLink$$() }}" target="_blank">
          {{ 'Data Act' }}
        </a>
      </div>
    </div>
  </mat-menu>
</div>

<ng-template #lgOrgView>
  <span
    [matBadge]="getAllNotificationsCount()"
    [matBadgeHidden]="getAllNotificationsCount() == 0"
    class="username hide-text"
    matBadgeOverlap="false"
    matBadgeSize="small">
    <span class="org-name" data-testid="current-organisation-name">{{ currentOrganisation()?.name }}</span>
  </span>
</ng-template>

<ng-template #leOrgView>
  <claas-icon
    [matBadge]="getAllNotificationsCount()"
    [matBadgeHidden]="getAllNotificationsCount() == 0"
    class="org-selector-farm-icon ml-2"
    iconName="agricultural_buisness_farm"
    [iconStyle]="'bold'"
    namespace="cc"
    [size]="22"
    matBadgeSize="small"
    data-testid="notification-menu-button">
  </claas-icon>
</ng-template>
